import { el } from '../js/utils.js';
import { t } from '../js/i18n.js';

export function renderFooter() {
  return el(
    'footer',
    { class: 'app-footer' },
    el(
      'p',
      { class: 'app-footer-copyright' },
      t('footer.copyright', { year: new Date().getFullYear() })
    )
  );
}
